import React, { FC, Fragment, useMemo } from 'react';
import { isFCShopCategory } from 'utils/functions';
import { BrandType, SearchType } from 'utils/types';
import { DropdownItem } from '@cokitchen/cokitchen-components';
import { ENUM_BRAND_TYPE } from 'utils/enum';
import { ReactComponent as ArchiveIcon } from 'assets/icons/archive-icon.svg';
import { ReactComponent as RestoreIcon } from 'assets/icons/restore.svg';
import { EditAltIcon } from 'cokitchen-icons';
import MoveBrandOptions from './move-brand-options';

export type BrandCardOptionType = 'archive' | 'restore' | 'edit' | 'select';

type BrandCardOptions = {
  options: BrandCardOptionType[];
  onClick: (type: BrandCardOptionType) => void;
  onMove?: (type: ENUM_BRAND_TYPE) => void;
  data: BrandType | SearchType;
};

const BrandCardOptions: FC<BrandCardOptions> = ({ data, options, onClick, onMove }) => {
  const { archived: isArchived } = data;
  const isFcShop = isFCShopCategory();

  const { archive, edit, restore } = useMemo(
    () =>
      options.reduce<Partial<Record<BrandCardOptionType, boolean>>>(
        (acc, o) => ({ ...acc, [o]: true }),
        {}
      ),
    [options]
  );

  return (
    <Fragment>
      {!isArchived ? (
        <Fragment>
          {edit && (
            <DropdownItem onClick={() => onClick('edit')} className='min-h-[38px]'>
              <div className='flex items-center gap-3 text-sm '>
                <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-auto py-1 px-1 shadow-md '>
                  <EditAltIcon />
                </div>
                <p> Edit {isFcShop ? 'shop' : 'brand'}</p>
              </div>
            </DropdownItem>
          )}
          {archive && (
            <DropdownItem className='min-h-[38px]' onClick={() => onClick('archive')}>
              <div className='flex gap-3 items-center text-sm'>
                <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-auto py-1 px-1 shadow-md '>
                  <ArchiveIcon />
                </div>
                <p> Archive {isFcShop ? 'shop' : 'brand'}</p>
              </div>
            </DropdownItem>
          )}
          {onMove && <MoveBrandOptions data={data} onMove={onMove} />}
        </Fragment>
      ) : (
        <Fragment>
          {restore && (
            <DropdownItem onClick={() => onClick('restore')} className='min-h-[38px]'>
              <div className='flex gap-4'>
                <div className='bg-white border-[0.6px] border-[#EAEAEB] rounded-full m-auto py-1 px-1 shadow-md '>
                  {' '}
                  <RestoreIcon />
                </div>
                <p> Restore brand</p>
              </div>
            </DropdownItem>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default BrandCardOptions;
